import React from "react";
import PropTypes from "prop-types";

export default function RuleFormButtons(props) {
  return (
    <p className="page__actions">
      <button
        type="button"
        className="btn btn-default"
        onClick={props.onCancel}
      >
        Cancel
      </button>

      <button
        type="button"
        className="btn btn-primary"
        data-loading-text="<i class='fa fa-spinner fa-spin'></i> <i class='fa fa-floppy-o'></i> Saving Rule"
        onClick={props.onSubmit}
      >
        <i className="fa fa-floppy-o" aria-hidden="true"></i>
        Save Rule
      </button>
    </p>
  );
}

RuleFormButtons.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
};
